module.exports = __webpack_public_path__ + "static/connect-hero-bd95bf98d5f8b3889c482174ca5bed7e.png";